import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "form__field" }
const _hoisted_2 = { class: "form__input" }
const _hoisted_3 = ["bgcolor"]
const _hoisted_4 = ["colspan"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_swatches = _resolveComponent("v-swatches")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { icon: "mdi-account-group" }),
          _createTextVNode("   Client: " + _toDisplayString(_ctx.client.name) + " ", 1),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        "align-tabs": "title",
        "bg-color": "teal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "Notes",
            text: "Notes"
          }),
          _createVNode(_component_v_tab, {
            value: "Activities",
            text: "Activities"
          }),
          _createVNode(_component_v_tab, {
            value: "Client Details",
            text: "Client Details"
          }),
          _createVNode(_component_v_tab, {
            value: "Progress",
            text: "Progress"
          }),
          _createVNode(_component_v_tab, {
            value: "Appointments",
            text: "Appointments"
          }),
          (_ctx.client.nextAppointment !== null)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 0,
                value: "Next Appointment",
                text: "Next Appointment"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_badge, {
                    color: "error",
                    dot: "",
                    inline: ""
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, {
            value: "Notes",
            key: "Notes"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_quill_editor, {
                content: _ctx.client.notes,
                "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client.notes) = $event)),
                contentType: "html",
                theme: "snow"
              }, null, 8, ["content"]),
              _createVNode(_component_v_btn, {
                disabled: _ctx.loading,
                loading: _ctx.loading,
                class: "text-none mb-4",
                color: "secondary",
                size: "large",
                variant: "flat",
                onClick: _ctx.onSetNotes
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Save ")
                ])),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            value: "Activities",
            key: "Activities"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, _createSlots({ _: 2 }, [
                        (!_ctx.client.allowToViewHealthData)
                          ? {
                              name: "title",
                              fn: _withCtx(() => [
                                _cache[12] || (_cache[12] = _createTextVNode(" User doesn't allow to show private data "))
                              ]),
                              key: "0"
                            }
                          : {
                              name: "title",
                              fn: _withCtx(() => [
                                _cache[13] || (_cache[13] = _createTextVNode("At this moment not implemented"))
                              ]),
                              key: "1"
                            }
                      ]), 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            value: "Client Details",
            key: "Client Details"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event)),
                style: {"height":"500px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.client.name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.client.name) = $event)),
                                counter: 30,
                                rules: _ctx.nameRules,
                                label: "Name",
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "form__label" }, [
                                  _createElementVNode("strong", null, "Choose a color:")
                                ], -1)),
                                _createElementVNode("div", _hoisted_2, [
                                  _createVNode(_component_v_swatches, {
                                    modelValue: _ctx.client.color,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client.color) = $event)),
                                    "show-fallback": "",
                                    "fallback-input-type": "color",
                                    "popover-x": "left"
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_combobox, {
                                modelValue: _ctx.client.objectives,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.client.objectives) = $event)),
                                label: "Objectives",
                                chips: "",
                                multiple: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.loading || !_ctx.valid,
                                loading: _ctx.loading,
                                class: "text-none mb-4",
                                color: "secondary",
                                size: "large",
                                variant: "flat",
                                onClick: _ctx.onUpdateClientInfo
                              }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode(" Save ")
                                ])),
                                _: 1
                              }, 8, ["disabled", "loading", "onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            value: "Progress",
            key: "Progress"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client.progress, (opacity, index) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: index,
                  style: _normalizeStyle({ opacity: opacity / 5 }),
                  class: "ma-2",
                  color: "primary",
                  variant: "flat",
                  label: ""
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("   ")
                  ])),
                  _: 2
                }, 1032, ["style"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            value: "Appointments",
            key: "Appointments"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: _ctx.filtersDialog,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filtersDialog) = $event)),
                "close-on-content-click": false,
                location: "end"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("mdi-cog")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { "min-width": "300" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        class: "ma-2",
                        modelValue: _ctx.showPreviousAppointments,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showPreviousAppointments) = $event)),
                        color: "secondary",
                        label: "Show previous appointments",
                        "hide-details": ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.appointmentStatus,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.appointmentStatus) = $event)),
                        items: _ctx.appointmentStatuses,
                        class: "ma-2",
                        label: "Appointment status",
                        variant: "outlined",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.paymentStatus,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paymentStatus) = $event)),
                        items: _ctx.paymentStatuses,
                        class: "ma-2",
                        label: "Payment status",
                        variant: "outlined",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            color: "primary",
                            onClick: _ctx.onClearFilters
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Clear filters ")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_data_table, {
                "group-by": _ctx.groupBy,
                headers: _ctx.headers,
                items: _ctx.clientAppointments,
                search: _ctx.search
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", {
                    bgcolor: _ctx.getRowColor(item)
                  }, [
                    _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1)),
                    _createElementVNode("td", null, _toDisplayString(item.slot), 1),
                    _createElementVNode("td", null, _toDisplayString(item.endTime), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: item.status,
                        "onUpdate:modelValue": [($event: any) => ((item.status) = $event), ($event: any) => (item.changed = true)],
                        items: _ctx.appointmentStatuses,
                        class: "ma-2",
                        variant: "solo",
                        "bg-color": _ctx.getAppointmentStatusColor(item.status),
                        chips: "",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "bg-color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_select, {
                        modelValue: item.paymentStatus,
                        "onUpdate:modelValue": [($event: any) => ((item.paymentStatus) = $event), ($event: any) => (item.changed = true)],
                        items: _ctx.paymentStatuses,
                        class: "ma-2",
                        variant: "solo",
                        "bg-color": _ctx.getPaymentStatusColor(item.paymentStatus),
                        chips: "",
                        dense: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "bg-color"])
                    ]),
                    _createElementVNode("td", null, [
                      (item.changed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            disabled: _ctx.loading,
                            loading: _ctx.loading,
                            density: "default",
                            variant: "flat",
                            color: "secondary",
                            onClick: ($event: any) => (_ctx.onUpdate(item))
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode(" Update ")
                            ])),
                            _: 2
                          }, 1032, ["disabled", "loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_3)
                ]),
                "group-header": _withCtx(({ item, columns, toggleGroup, isGroupOpen }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: columns.length
                    }, [
                      _createVNode(_component_VBtn, {
                        icon: isGroupOpen(item) ? '$expand' : '$next',
                        size: "small",
                        variant: "text",
                        onClick: ($event: any) => (toggleGroup(item))
                      }, null, 8, ["icon", "onClick"]),
                      _createTextVNode(" " + _toDisplayString(item.value), 1)
                    ], 8, _hoisted_4)
                  ])
                ]),
                _: 1
              }, 8, ["group-by", "headers", "items", "search"])
            ]),
            _: 1
          }),
          (_ctx.client.nextAppointment !== null)
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                value: "Next Appointment",
                key: "Next Appointment"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Date:", -1)),
                                    _createTextVNode(" " + _toDisplayString((_ctx.client.nextAppointment.appointmentDate)), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Time:", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.client.nextAppointment.slot), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              (_ctx.client.nextAppointment?.callUrl !== null)
                                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("iframe", {
                                        src: _ctx.client.nextAppointment.callUrl,
                                        width: "100%",
                                        height: "700",
                                        frameborder: "0",
                                        allowfullscreen: "",
                                        sandbox: "allow-scripts allow-same-origin",
                                        allow: "camera https://meet.sequoia.health; microphone https://meet.sequoia.health"
                                      }, null, 8, _hoisted_5)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                      _createElementVNode("p", null, "No call URL available for this appointment.", -1)
                                    ])),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}